import { on } from 'delegated-events'
import { handleValidation } from '@common/validation'
import ajax from '@common/ajax'
import scrollTo from '@common/scroll-to'
import { trackGoogleAnalytics } from '@common/util'

const wrapper = document.querySelector('.donate-form-wrapper')
const form = document.querySelector('.donate-form')
const submitButton = form.querySelector('[type=submit]')
const amountView = form.querySelector('.amount-view')
const detailsView = form.querySelector('.details-view')
const paymentView = form.querySelector('.payment-view')
const amountField = form.querySelector('input[name=Amount]')
const summaryField = form.querySelector('.payment-summary')
const cardElement = document.getElementById('card-element')

const recurringLabels = {
  weekly: 'week',
  monthly: 'month',
  annually: 'year',
}

const state = {
  stripe: null,
  stripeCard: null,
  view: 'amount',
  frequency: form.querySelector('input[name="Frequency"]:checked').value,
  recurringFrequency: form.querySelector('select[name="RecurringFrequency"]').value,
  paymentRequest: null
}

const render = () => {
  if (state.view === 'amount') {
    amountView.classList.add('is-active')
    detailsView.classList.remove('is-active')
    paymentView.classList.remove('is-active')
  }

  if (state.view === 'details') {
    amountView.classList.remove('is-active')
    detailsView.classList.add('is-active')
    paymentView.classList.remove('is-active')

    let summary = `$ ${amountField.value}.00`

    if (state.frequency === 'Recurring') {
      summary = `${summary} every ${recurringLabels[state.recurringFrequency]}`
    }

    summaryField.value = summary
  }

  if (state.view === 'payment') {
    amountView.classList.remove('is-active')
    detailsView.classList.remove('is-active')
    paymentView.classList.add('is-active')
  }

  scrollTo(wrapper)
}

const setupPayment = () => {
  if (cardElement) {
    state.stripe = window.Stripe(form.dataset.stripePubKey)

    setupStripeCard()

    form.addEventListener('submit', handleSubmit)
  }
}

const setupApplePay = () => {

    let donationAmount = 0
    if (amountField.value != '') {
        donationAmount = amountField.value
        donationAmount = parseFloat(donationAmount.replaceAll(',', '')) * 100
    }

    const paymentRequest = state.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Kelberman',
        amount: donationAmount
      },
      requestPayerName: true,
      requestPayerEmail: true,
      requestPayerPhone: true
    })

    const paymentRequestButton = state.stripe.elements().create('paymentRequestButton', {
      paymentRequest: paymentRequest,
      style: {
        paymentRequestButton: {
          height: '55px'
        }
      }
    })

    // Check the availability of the Payment Request API first
    paymentRequest.canMakePayment().then(function(result) {
      if (result && result.applePay) {
        if (document.getElementById('payment-request-button')){
            paymentRequestButton.mount('#payment-request-button');
            state.paymentRequest = paymentRequest
        }

        //$form.classList.add('has-thirdparty')
      } else {
        if (document.getElementById('payment-request-button')){
            document.getElementById('payment-request-button').style.display = 'none';
        }
      }
    })

    paymentRequest.on('token', (e) => {
      const hiddenInput = document.createElement('input')
      hiddenInput.setAttribute('type', 'hidden')
      hiddenInput.setAttribute('name', 'stripeApplePayToken')
      hiddenInput.setAttribute('value', e.token.id)
      form.appendChild(hiddenInput)

      form.forceSubmit = true
      submitButton.disabled = false
      submitButton.classList.remove('hidden')
      submitButton.click()
      submitButton.disabled = true
      submitButton.classList.add('hidden')
    })
}


const setupGooglePay = () => {

    let donationAmount = 0
    if (amountField.value != '') {
        donationAmount = amountField.value
        donationAmount = parseFloat(donationAmount.replaceAll(',', '')) * 100
    }

    const paymentRequest = state.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: 'Kelberman',
        amount: donationAmount
      },
      requestPayerName: true,
      requestPayerEmail: true,
      requestPayerPhone: true
    })

    const paymentRequestButton = state.stripe.elements().create('paymentRequestButton', {
      paymentRequest: paymentRequest,
      style: {
        paymentRequestButton: {
          height: '55px'
        }
      }
    })

    // Check the availability of the Payment Request API first
    paymentRequest.canMakePayment().then(function(result) {
      if (result && result.googlePay) {
        if (document.getElementById('google-payment-request-button')){
            paymentRequestButton.mount('#google-payment-request-button');
            state.paymentRequest = paymentRequest
        }

        //$form.classList.add('has-thirdparty')
      } else {
        if (document.getElementById('google-payment-request-button')){
            document.getElementById('google-payment-request-button').style.display = 'none';
        }
      }
    })

    paymentRequest.on('token', (e) => {
      const hiddenInput = document.createElement('input')
      hiddenInput.setAttribute('type', 'hidden')
      hiddenInput.setAttribute('name', 'stripeGooglePayToken')
      hiddenInput.setAttribute('value', e.token.id)
      form.appendChild(hiddenInput)

      form.forceSubmit = true
      submitButton.disabled = false
      submitButton.classList.remove('hidden')
      submitButton.click()
      submitButton.disabled = true
      submitButton.classList.add('hidden')
    })
}

const handleSubmit = async (e) => {

  if (e.target.forceSubmit) {
    submitAppleGooglePay()
  }

  e.preventDefault()

  const form = e.target
  const submitButton = form.querySelector('[type=submit]')
  const isValid = handleValidation(form)

  if (isValid) {
    submitButton.disabled = true
    submitButton.classList.add('hidden')

    const result = await state.stripe.createToken(state.stripeCard)

    if (result.error) {
      const errorElement = document.getElementById('card-errors')
      errorElement.textContent = result.error.message
      submitButton.disabled = false
      submitButton.classList.remove('hidden')
    } else {
      stripeTokenHandler(result.token)
    }
  }
}

const stripeTokenHandler = (token) => {
  const hiddenInput = document.createElement('input')
  hiddenInput.setAttribute('type', 'hidden')
  hiddenInput.setAttribute('name', 'stripeToken')
  hiddenInput.setAttribute('value', token.id)
  form.appendChild(hiddenInput)

  const formMessages = form.querySelector('.form-messages')
  const submitButton = form.querySelector('[type=submit]')
  let autoHideMessage = form.dataset.autoHideMessage ? form.dataset.autoHideMessage === 'true' : true

  const formData = new FormData(form)

  ajax
    .url(form.action)
    .body(formData)
    .post()
    .json((res) => {
      if (res.success) {
        if (res.ga) {
          res.ga.forEach((event) => trackGoogleAnalytics(event))
        }

        form.reset()
        form.querySelectorAll('select').forEach((x) => (x.value = null))
        form.querySelectorAll('.toggle-fields').forEach((x) => x.classList.add('hidden'))
        form.querySelectorAll('.toggle-group').forEach((x) => x.classList.add('hidden'))

        if (form.dataset.hideOnSubmit) {
          form.querySelectorAll('.form-content').forEach((x) => x.classList.add('hidden'))
          document.querySelectorAll('.hide-on-form-submit').forEach((x) => x.classList.add('invisible'))
          autoHideMessage = false

          const shouldScroll = form.dataset.formScroll !== undefined

          if (shouldScroll) {
            scrollTo(form, 32)
          }
        }
      }

      if (res.message) {
        showFormMessages(formMessages, res.message, res.success, autoHideMessage)
      }
    })
    .catch(() => {
      submitButton.disabled = false
      submitButton.classList.remove('hidden')
      showFormMessages(formMessages, 'Sorry, there was a problem with your submission')
    })
    .finally(() => {
      submitButton.disabled = false
      submitButton.classList.remove('hidden')
    })
}

const submitAppleGooglePay = () => {

    const formMessages = form.querySelector('.form-messages')
    const submitButton = form.querySelector('[type=submit]')
    let autoHideMessage = form.dataset.autoHideMessage ? form.dataset.autoHideMessage === 'true' : true

    const formData = new FormData(form)

    ajax
      .url(form.action)
      .body(formData)
      .post()
      .json((res) => {
        if (res.success) {
          if (res.ga) {
            res.ga.forEach((event) => trackGoogleAnalytics(event))
          }

          form.reset()
          form.querySelectorAll('select').forEach((x) => (x.value = null))
          form.querySelectorAll('.toggle-fields').forEach((x) => x.classList.add('hidden'))
          form.querySelectorAll('.toggle-group').forEach((x) => x.classList.add('hidden'))

          if (form.dataset.hideOnSubmit) {
            form.querySelectorAll('.form-content').forEach((x) => x.classList.add('hidden'))
            document.querySelectorAll('.hide-on-form-submit').forEach((x) => x.classList.add('invisible'))
            autoHideMessage = false

            const shouldScroll = form.dataset.formScroll !== undefined

            if (shouldScroll) {
              scrollTo(form, 32)
            }
          }
        }

        if (res.message) {
          showFormMessages(formMessages, res.message, res.success, autoHideMessage)
        }
      })
      .catch(() => {
        submitButton.disabled = false
        submitButton.classList.remove('hidden')
        showFormMessages(formMessages, 'Sorry, there was a problem with your submission')
      })
      .finally(() => {
        submitButton.disabled = false
        submitButton.classList.remove('hidden')
      })
  }

const showFormMessages = (holder, message, success, autoHide) => {
  holder.style.display = 'block'
  holder.innerHTML = message

  if (success) {
    holder.classList.remove('form-message-error')
  } else {
    holder.classList.add('form-message-error')
  }

  if (autoHide) {
    setTimeout(() => {
      holder.style.display = 'none'
    }, 5000)
  }
}

const setupStripeCard = () => {
  const style = {
    base: {
      fontSize: '16px',
      fontFamily: 'filson-soft, sans-serif',
      color: '#415364',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#415364',
      },
    },
    invalid: {
      color: '#b9112a',
    },
  }

  const card = state.stripe.elements().create('card', { style })

  card.mount('#card-element')
  state.stripeCard = card

  card.addEventListener('change', ({ error }) => {
    const displayError = document.getElementById('card-errors')

    if (error) {
      displayError.textContent = error.message
    } else {
      displayError.textContent = ''
    }
  })
}

const init = () => {
  on('click', '.donation-amount', (e) => {
    const amount = e.target.dataset.value

    const updateEvent = new CustomEvent('updateValue', { detail: amount })

    amountField.dispatchEvent(updateEvent)
  })

  on('click', 'input[name="Frequency"]', (e) => {
    if (e.target.checked) {
      state.frequency = e.target.value
    }
  })

  on('change', 'select[name="RecurringFrequency"]', (e) => {
    state.recurringFrequency = e.target.value
  })

  on('click', '.details-view-trigger', () => {
    const isValid = handleValidation(form)


    if (isValid) {
      state.view = 'details'

      render()
    }
  })

  on('click', '.amount-view-trigger', () => {
    state.view = 'amount'
    render()
  })

  on('click', '.payment-view-trigger', () => {
    const isValid = handleValidation(form)


    if (isValid) {
      state.view = 'payment'

      setupApplePay()
      setupGooglePay()

      render()
    }
  })

  setupPayment()

}

init()
